(() => {
  'use strict';
  if (!window.customElements || customElements.get('printique-newsletter-popup')) return;
  const dismissedKey = 'printique-newsletter-dismissed-v1';
  const subscribedKey = 'printique-newsletter-subscribed-v1';
  const seenKey = 'printique-newsletter-seen-v1';
  const read = (storage, key) => { try { return storage.getItem(key); } catch (_) { return null; } };
  const write = (storage, key, value) => { try { storage.setItem(key, value); } catch (_) {} };
  customElements.define('printique-newsletter-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || !this.dialog.showModal) return;
      const result = this.querySelector('[data-pq-result]')?.dataset.pqResult;
      const preview = new URLSearchParams(location.search).get('newsletter') === '1';
      const show = () => {
        if (!this.isConnected || this.dialog.open) return true;
        if (document.hidden || document.querySelector('dialog[open]') || document.activeElement?.matches('input,textarea,select,[contenteditable=true]')) return false;
        this.dialog.showModal();
        this.querySelector('[data-pq-close]').focus({preventScroll:true});
        if (!preview) write(sessionStorage, seenKey, '1');
        return true;
      };
      this.querySelectorAll('[data-pq-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => { if (!preview) write(localStorage, dismissedKey, String(Date.now())); });
      if (result === 'success') write(localStorage, subscribedKey, '1');
      if (preview || result) { show(); return; }
      if (this.dataset.knownCustomer === 'true' || read(localStorage, subscribedKey) || read(sessionStorage, seenKey)) return;
      const dismissed = Number(read(localStorage, dismissedKey) || 0);
      if (dismissed && Date.now() - dismissed < 7 * 86400000) return;
      let tries = 0;
      const attempt = () => { if (!show() && ++tries < 12) this.timer = setTimeout(attempt, 10000); };
      this.timer = setTimeout(attempt, Number(this.dataset.delay || 30) * 1000);
    }
    disconnectedCallback() { clearTimeout(this.timer); }
  });
})();
